
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  { path: 'reservation/order_list_new', component: loadPage('OrderListNew', 'reservation/order') },
  { path: 'reservation/order_list_all', component: loadPage('OrderListAll', 'reservation/order') },
  { path: 'reservation/order_detail', component: loadPage('OrderDetail', 'reservation/order') },
  { path: 'reservation/order_create', component: loadPage('OrderCreate', 'reservation/order') },
  { path: 'reservation/order_calendar', component: loadPage('OrderCalendar', 'reservation/order') },

  { path: 'reservation/order_list_cancel_new', component: loadPage('OrderListCancelNew', 'reservation/order') },
  { path: 'reservation/order_list_cancel_all', component: loadPage('OrderListCancelAll', 'reservation/order') },


  // 정산
  { path: 'reservation/account/new', component: loadPage('AccountNew', 'reservation/order') },
  { path: 'reservation/account/all', component: loadPage('AccountAll', 'reservation/order') },
  { path: 'reservation/account/setting', component: loadPage('AccountSetting', 'reservation/order') },
];


const routes_admin = [

];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base)
};

export default routes;

